document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.collection-grid__container');
  const inner = document.querySelector('.collection-grid__inner');
  
  if (!container || !inner) return;

  gsap.to(inner, {
    y: '-50%',
    ease: 'none',
    duration: 20,
    repeat: -1,
    scrollTrigger: {
      trigger: container,
      start: 'top top',
      end: 'bottom top',
      scrub: false,
    }
  });

  // Reset animation when items are out of view
  const resetAnimation = () => {
    const rect = inner.getBoundingClientRect();
    if (rect.bottom <= 0) {
      gsap.set(inner, { y: '100%' });
    }
  };

  gsap.ticker.add(resetAnimation);
});
